import useBrandingConfig from '@client-info/features/insurancePolicy/hooks/useBrandingConfig';

export const FALLBACK_APP_NAME = 'Safeture';

export const useAppName = () => {
  const { data, isPending } = useBrandingConfig();
  const appName = data?.appName ?? FALLBACK_APP_NAME;
  return {
    appName,
    // White labels get copy that discloses Safeture as the provider
    isWhiteLabel: appName !== FALLBACK_APP_NAME,
    isPending,
  };
};
